module.exports = __webpack_public_path__ + "static/images/Auth_logo.9b658bd7e29fbdfcc350f471ad1584d3.png";